import { t as __t } from "i18next";
import React, { useState, useEffect } from "react";
import { notifyListRefresh } from "../../../utils/listNavigation";
import { useDispatch } from "react-redux";
import { callEditEditPolicy, callGetPolicyById, callGetPolicyTypeAll } from "../../../api/settings/service";
import CopyrightFooter from "../../../components/footer/employers/CopyrightFooter";
import DashboardHeader from "../../../components/header/DashboardHeader";
import BackPrevious from "../../../components/back-previous";
import DashboardEmployerSidebar from "../../../components/header/DashboardSidebar";
import MobileMenu from "../../../components/header/MobileMenu";
import { handleInput, } from "../../../utils/commonUtil";
import { toast } from "react-toastify";
import "../../../components/i18n/lang";
import { decodeBase64, handleGetCookie } from "../../../utils/commonUtil"
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import colors from '../../../utils/colors'

const Index = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const [policy, setPolicy] = useState({ id: null, policyName: '', detailLA: '', detailEN: '', policyTypeID: '', modifiedCode: '', modifiedName: '' });
	const [policyType, setPolicyType] = useState([])
	let params = useParams();

	useEffect(() => {
		loadPolicyType()

		if (Object.keys(params).length > 0) {
			let id = decodeBase64(params?.id)
			if (id != null) {
				getPolicyById(id)
			}
		}

	}, []);

	const loadPolicyType = async () => {
		try {
			const rsp = await dispatch(callGetPolicyTypeAll());
			if (rsp?.payload?.responseCode === "00000") {
				setPolicyType(rsp?.payload?.data)
			}
		} catch (error) {
			console.error(error)
		}
	}

	const getPolicyById = async (id) => {
		try {
			const rsp = await dispatch(callGetPolicyById({ id }));
			if (rsp?.payload?.responseCode === "00000") {
				const item = rsp?.payload?.data
				console.log(item)
				setPolicy((prev) => ({
					...prev,
					id: id,
					brandName: item.brandName || '',
					brandNameEn: item.brandNameEn || '',
					policyName: item.policyName,
					detailLA: item.detailLa,
					detailEN: item.detailEn,
					policyTypeID: item.policyTypeId,
				}));
			}

			const authData = handleGetCookie('auth');
			console.log(authData)
			if (authData?.user?.userId) {
				setPolicy((prev) => ({
					...prev,
					modifiedCode: authData?.user?.userId,
					modifiedName: authData?.user?.firstName + " " + (authData?.user?.lastName === null ? '' : authData?.user?.lastName),
				}));
			}
		} catch (error) {
			console.error(error)
		}
	};

	const handleChange = (e) => {
		const { name, value } = e.target;
		setPolicy({
			...policy,
			[name]: value,
		});
	};

	const handleSave = async (e) => {
		e.preventDefault()

		Swal.fire({
			title: t("titleSave"),
			text: t("confirmSave"),
			icon: "warning",
			reverseButtons: true,
			showCancelButton: true,
			confirmButtonColor: colors.confirmMessage,
			cancelButtonColor: colors.cancel,
			confirmButtonText: t('confirm'),
			cancelButtonText: t('cancel')
		}).then(async (result) => {
			if (result.isConfirmed) {
				try {

					if (policy.id != null) {
						let req = {
							id: policy.id,
							policyName: policy.policyName,
							detailLA: policy.detailLA,
							detailEN: policy.detailEN,
							policyTypeID: policy.policyTypeID,
							modifiedCode: policy.modifiedCode,
							modifiedName: policy.modifiedName
						}
						const res = await dispatch(callEditEditPolicy(req));
						if (res?.payload?.responseCode === "00000") {
							Swal.fire({
								icon: "success",
								title: t("success.add"),
								confirmButtonColor: colors.confirmMessage,
								confirmButtonText: t('close'),
							}).then(function () {
								notifyListRefresh();
								navigate(-1);
							});
						} else {
							toast.error(res?.payload?.responseCode + " - " + res?.payload?.responseDescription, {
								position: "top-left"
							})
						}
					}
				} catch (error) {
					Swal.fire(__t("uiText.text023"), __t("uiText.text024"), "error");
				}
			}
		});
	}

	const selectPolicyType = (e) => {
		setPolicy((prev) => ({
			...prev,
			policyTypeID: e.target.value,
		}));
	}

	return (
		<div className="page-wrapper dashboard">
			<span className="header-span"></span>
			<DashboardHeader />
			<MobileMenu />
			<DashboardEmployerSidebar />
			<form onSubmit={handleSave}>
				<section className="user-dashboard">
					<div className="dashboard-outer">
						<div className="upper-title-box back-title-group">
							<BackPrevious />
							<h4>{t("settings.policy.edit")}</h4>
						</div>

						<div className="ls-widget">
							<div className="tabs-box">
								<div className="widget-content p-4">
									<div className="default-form">
										<div className="row">
											<div className="col-md-6 form-group">
												<label> {t('settings.policy.name')} <span className="text-danger">*</span> </label>
												<input
													type="text"
													name="policyName"
													className="form-control-uld"
													placeholder={t('settings.policy.name')}
													onInput={handleInput}
													onChange={handleChange}
													value={policy.policyName}
													autoComplete="off"
													required />
											</div>
											<div className="col-md-6 form-group">
												<label> {t('settings.policy.policyType')}<span className="text-danger">*</span> </label>
												<select className="chosen-single form-select"
													onChange={selectPolicyType}
													value={policy.policyTypeID}
													required
												>
													<option key={0} value="">{t("pleaseSelect")}</option>
													{
														policyType.map((item) => (
															<option key={item.id} value={item.id}>{item.typeName}</option>
														))
													}
												</select>
											</div>
											<div className="col-12 col-md-12 form-group">
												<label> {t('settings.policy.detailLa')} <span className="text-danger">*</span> </label>
												<textarea
													name="detailLA"
													placeholder={t('settings.policy.detailLa')}
													value={policy.detailLA}
													onChange={handleChange}
													required>
												</textarea>
											</div>
											<div className="col-12 col-md-12 form-group">
												<label> {t('settings.policy.detailEn')} <span className="text-danger">*</span> </label>
												<textarea
													name="detailEN"
													placeholder={t('settings.policy.detailEn')}
													value={policy.detailEN}
													onChange={handleChange}
													required>
												</textarea>
											</div>

											<div className="col-12 d-flex justify-content-center">
												<div className="m-3">
													<button className="theme-btn btn-style-one w-100" type="submit">
														<i className="fas fa-add"></i>&nbsp;{t("button.save")}
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
			</form>
			<CopyrightFooter />
		</div>
	);
};

export default Index;
